import { useStories } from './storyblok-proxy/useStories';
import { useCurrentSectionConfig } from './useCurrentSectionConfig';

export interface MappedCategory {
    id: string;
    value: string;
    key: string;
    nameLocalized: string | null;
    subcategories: MappedCategory[];
}

export const useNewsCategories = async () => {
    const categories = ref<MappedCategory[]>([]);
    const route = useRoute();
    const matchedConfig = useCurrentSectionConfig();

    try {
        const params = computed(() => {
            const clean = route.path.replace(/\/+$/, '');
            const segs = clean.split('/').filter(Boolean);
            const root = decodeURIComponent(segs.at(-1) ?? '');
            const rootPath = matchedConfig.value?.sectionRootPath || '/';
            const starts_with = matchedConfig.value?.sectionRootPath === '/' ? `${root}` : `${rootPath}/${root}`;

            return {
                starts_with,
                filter_query: {
                    component: {
                        in: 'categories'
                    }
                }
            };
        });
        const { data: result } = await useStories<CategoriesStoryblok>(params);

        const story = result.value?.[0];

        if (story?.content?.categories) {
            categories.value = buildCategoryHierarchy(story.content.categories);
        } else {
            console.warn('No categories found for the chosen path');
        }
    } catch (error) {
        console.error('Error fetching categories:', error);
    }

    return categories;
};

const buildCategoryHierarchy = (categories: CategoryStoryblok[]): MappedCategory[] => {
    return categories.map((category: CategoryStoryblok) => ({
        id: category._uid,
        value: category.value,
        key: category.key,
        nameLocalized: category.nameLocalized || null,
        subcategories: category.children ? buildCategoryHierarchy(category.children) : []
    }));
};
